<template>
  <div class="villaboxes">
      <VillaBox v-for='v in villas' :key="v.name" :v="v"></VillaBox>
  </div>
</template>
<script>
import VillaBox from './VillaBox'

export default {
  props: ['villas'],
  components: {
    VillaBox
  }
}
</script>

<style lang="less" scoped>

@import '../css/globals.less';

div.villaboxes {
  font-family: @cursive-font;
  display: flex;
  flex-direction: column;
  font-size: @default-font-size;
}
</style>


// WEBPACK FOOTER //
// src/components/VillaBoxes.vue